import { createSlice } from '@reduxjs/toolkit';

const templatesSlice = createSlice({ name: 'templates', reducers: {}, initialState: {} });

export default templatesSlice.reducer;
